import { useTranslation } from 'react-i18next';
import React from 'react';
import { FiClock, FiCheck, FiTrendingUp, FiFileText } from 'react-icons/fi';
import { KpiCard, KpiCardExplanation, KpiCardMetric, KpiCardMetrics, KpiCardTitle, KpiCardValue } from '@/components/custom/kpi';
import { CardIcon } from '@/components/ui/card';

export function ExercisesMetricsCardKpi(props) {
  const { cardIcon, cardTitle, cardValue, cardPercentage, cardPeriod } = props;

  const { t } = useTranslation();

  function printIcon(value) {
    switch (value) {
      case 'clock':
        return <FiClock />;
      case 'check':
        return <FiCheck />;
      case 'arrow':
        return <FiTrendingUp />;
      default:
        return <FiFileText />;
    }
  }

  function printPeriod(value) {
    switch (value) {
      case 'dia':
        return t('questionBooks.lastDay');
      case 'semana':
        return t('questionBooks.lastWeek');
      case 'mes':
        return t('questionBooks.lastMonth');
      default:
        return t('questionBooks.lastMonth');
    }
  }

  function validatePercentage(value) {
    if (value < 0) {
      return t('questionBooks.less');
    } else {
      return t('questionBooks.more');
    }
  }

  return (
    <KpiCard>
      <CardIcon
        className="p-2"
        roundedFull
      >
        {printIcon(cardIcon)}
      </CardIcon>
      <KpiCardTitle>{cardTitle}</KpiCardTitle>
      <KpiCardValue>{cardValue}</KpiCardValue>
      <KpiCardMetrics>
        <KpiCardMetric trend={cardPercentage > 0 ? 'positive' : 'negative'}>
          {cardPercentage}% {validatePercentage(cardPercentage)}
        </KpiCardMetric>
        <KpiCardExplanation>
          {t('questionBooks.what')} {printPeriod(cardPeriod)}
        </KpiCardExplanation>
      </KpiCardMetrics>
    </KpiCard>
  );
}
